export default __webpack_public_path__ + "static/media/Siemens.35c79808.PNG";